import {
    DmsPage, DmsAltBox, DmsTabber, intl
} from "dmsbasereact"
import { Typography } from "@mui/material";
import { PatientTable } from "../../components/PatientTable/PatientTable";
import { PatientStatusReasonTable } from "../../components/PatientStatusReasonTable";

export const PatientPage = () => {
    const tabs = [
        {
            title: intl.get("Patients").d("Patients"),
            component: <PatientTable />,
        },
        {
            title: intl.get("PatientStatusReasons").d("Patient Status Reasons"),
            component: <PatientStatusReasonTable />,
        },
    ];

    return (
        <DmsPage name='Patient'>
            <DmsAltBox.Card>
                <DmsAltBox.Header>
                    <Typography variant='h3' sx={{ fontSize: '1.1rem' }}>
                        {intl.get("Patient").d("Patient")}
                    </Typography>
                </DmsAltBox.Header>
                <DmsAltBox.Body>
                    <DmsTabber tabs={tabs} pageName={intl.get("Patient").d("Patient")} />
                </DmsAltBox.Body>
            </DmsAltBox.Card>
        </DmsPage>
    )
}
